import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.utv.production,
  name: sharedEnvironment.utv.name,
  bpUrl: sharedEnvironment.utv.bpUrl,
  etjansterCommonUrl: sharedEnvironment.utv.etjansterCommonApiUrl,
  cookieDomain: sharedEnvironment.utv.cookieDomain,
  utlysningsbyggareUrl: sharedEnvironment.utv.utlysningsbyggareUrl,
  utlysningsbyggareApiUrl: `${sharedEnvironment.utv.utlysningsbyggareApiUrl}`,
  forhandsgranskaUrl: sharedEnvironment.utv.forhandsgranskaUrl,
  etjansterCommonApiUrl: `${sharedEnvironment.utv.etjansterCommonApiUrl}/api`,
  resourceStringUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring/utlysningsbyggare`,
  sprakHanteringApiUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring`,
  logServiceApiUrl: `${sharedEnvironment.utv.gatewayUrl}/logger`,
  externalLinks: sharedEnvironment.utv.externalLinks,
  baseGatewayUrl: sharedEnvironment.utv.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.utv.apimSubscriptionKey,
  tinyMceApiKey: sharedEnvironment.utv.tinyMceApiKey,
  usePremiumTinyMceFeatures: true,
  etjansterCommonApiScope:
    sharedEnvironment.utv.azureAd.etjansterCommonApiScope,
  featureUrl: `${sharedEnvironment.utv.utlysningsbyggareApiUrl}/feature`,

  msalConfig: {
    ...sharedEnvironment.msalConfig(
      sharedEnvironment.utv.utlysningsbyggareApiUrl,
      '39175e04-8fc8-4d1c-892a-2f3cb242d525',
      '35cbeef4-867f-44df-a7f5-5d81162bce09',
      sharedEnvironment.utv.utlysningsbyggareUrl,
    ),
    allowRedirectInIframe: false,
  },
};
